import { encodeHashCobranca } from '@hyperdev-tech/hash-cobranca'
import type { Pagamento } from '@/types'

export function linkDaCobranca(pagamento: Pagamento): string | null {
  if (pagamento.meioPagamento === 'ISENTO') return null

  if (pagamento.provedorPagamento === 'EFI') {
    if (!pagamento.hashPagamento) return null
    return `${siteUrl()}/pagamento/${pagamento.hashPagamento}`
  }

  if (pagamento.provedorPagamento === 'HYPERPAY') {
    if (!pagamento.referenciaPagamento) return null
    return `https://conta.pilotar.app/cobranca/${encodeHashCobranca(+pagamento.referenciaPagamento)}`
  }

  return null
}

function siteUrl(): string {
  return import.meta.env.VITE_SITE_URL ?? 'https://newdriver.com.br'
}
